import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteCustomer = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}customers/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteCustomer;
